import { Observable } from 'rxjs';
import { filter } from 'rxjs/operators';

import { ApplicationRef, Injectable } from '@angular/core';
import { MatDialog, MatDialogConfig, MatDialogRef } from '@angular/material/dialog';

import { SnConfirmDialogComponent } from '../components/confirm-dialog/confirm-dialog.component';
import {
  ISnInfoDialogConfig,
  InfoDialogComponent,
} from '../components/info-dialog/info-dialog.component';
import { LoadingMessageDialogComponent } from '../components/loading-message-dialog/loading-message-dialog.component';
import { FsInputDialogComponent } from '../components/name-dialog/name-dialog.component';
import { TimeoutDialogComponent } from '../components/timeout-dialog/timeout-dialog.component';
import { VideoDialogComponent } from '../components/video-dialog/video-dialog.component';
import { IConfirmDialogConfig } from '../interfaces/confirm-dialog-config.interfaces';

@Injectable()
export class SnDialogService {
  constructor(
    private readonly _matDialog: MatDialog,
    private readonly _applicationRef: ApplicationRef,
  ) {}

  public confirm(config: IConfirmDialogConfig): Observable<any> {
    const dialogRef = this._matDialog.open(SnConfirmDialogComponent, {
      data: config,
      id: 'confirmDialog',
    });
    this._applicationRef.tick();
    if (config.actionOnClose) {
      return dialogRef.afterClosed();
    }
    return dialogRef.afterClosed().pipe(filter((confirm: any) => confirm));
  }

  public info(config: ISnInfoDialogConfig, panelClass?: string): Observable<any> {
    return this._matDialog
      .open(InfoDialogComponent, {
        data: config,
        panelClass,
        disableClose: true,
      })
      .afterClosed();
  }

  public mp4(src: string): Observable<any> {
    return this._matDialog
      .open(VideoDialogComponent, {
        data: src,
      })
      .afterClosed();
  }

  public name(config: any): Observable<any> {
    return this._matDialog
      .open(FsInputDialogComponent, {
        ...config,
      })
      .afterClosed();
  }

  public loadingMessageDialog(config: MatDialogConfig): MatDialogRef<any> {
    return this._matDialog.open(LoadingMessageDialogComponent, {
      ...config,
    });
  }

  public timeoutMessage(config: MatDialogConfig): MatDialogRef<any> {
    return this._matDialog.open(TimeoutDialogComponent, {
      ...config,
    });
  }
}
